import { MouseEvent, useCallback, useContext, useEffect, useState } from "react";
import { Badge, Nav } from "react-bootstrap";
import { makeid } from "utils/random";
import { NewTableContext } from ".";

interface ITableNavItem{
  label: string;
  count?: number;
  value: any;
}

interface ITableNavProps extends React.HTMLProps<HTMLElement>{
  items: ITableNavItem[];
  defaultActiveKey?: any;
  dataField: string;
  setAll?: boolean;
  loading?: boolean;
}

export default function TableNav({defaultActiveKey, onChange, dataField, setAll, items, loading, ...props}:ITableNavProps){
  const [ action, setAction ] = useState(()=>{
    if(setAll){
      return items.reduce((t,item)=>{
        if(t === "") return item.value;
        return `${t},${item.value}`;
      },"");
    }
    return undefined;
  });
  const { setFilter } = useContext(NewTableContext);

  useEffect(()=>{
    if(setAll){
      return setAction(items.reduce((t,item)=>{
        if(t === "") return item.value;
        return `${t},${item.value}`;
      },""));
    }
  },[items, setAll]);

  useEffect(()=>{
    if(defaultActiveKey)setAction(defaultActiveKey);
  },[defaultActiveKey]);

  const change = useCallback((value)=>{
    if(onChange)onChange(value);
    if(dataField && setFilter){
      let filter:any = {};
      filter[dataField] = value;
      setFilter(filter);
    }
  },[dataField,onChange,setFilter]);

  useEffect(()=>{
    change(action);
  },[change, action])

  function renderItems(){
    function renderAll(){
      let total = items.reduce((t,item)=>{
        return t+(item.count?item.count:0);
      },0);
      let value = items.reduce((t,item)=>{
        if(t === "") return item.value;
        return `${t},${item.value}`;
      },"")
      let isActive = action === value;
      let classActive = isActive?"btn-primary":"btn-secondary";
      let ID = `new-table-nav-item-${makeid(7)}-${makeid(5)}`;
      
      if(setAll){
        return (
          <Nav.Item
            className="new-table-nav-item btn-primary"
            onClick={({currentTarget}:MouseEvent)=>{
              let count = currentTarget.getElementsByClassName("new-table-nav-item-count")[0];
              if(count){
                count.classList.add("btn-primary");
              }
              setAction(value);
            }}
          >
            <Nav.Link id={ID} className={classActive}>
              Todos
              <Badge bg="info">{total}</Badge>
            </Nav.Link>
          </Nav.Item>
        );
      }
      return <></>;
    }
    if(items){
      return (
        <>
          {
            items.map((item,key)=>{
              let isActive = action === item.value;
              let classActive = isActive?"btn-primary":"btn-secondary";
              let ID = `new-table-nav-item-${makeid(7)}-${makeid(5)}`;
              return (
                <Nav.Item 
                  key={key}
                  className="new-table-nav-item"
                  onClick={({currentTarget}:MouseEvent)=>{
                    let count = currentTarget.getElementsByClassName("new-table-nav-item-count")[0];
                    if(count){
                      count.classList.add("btn-primary");
                    }
                    setAction(item.value);
                  }}
                >
                  <Nav.Link id={ID} className={classActive}>
                    {item.label}
                    {item.count || item.count === 0?(
                      <Badge bg="info">{loading?"-":item.count}</Badge>
                      // <div className={"new-table-nav-item-count "+classActive}>{item.count}</div>
                    ):null}
                  </Nav.Link>
                </Nav.Item>
              );
            })
          }
          {renderAll()}
        </>
      );
    } 
    return null;
  }

  return(
    <Nav variant="pills" className="new-table-nav" defaultActiveKey={action}>
      {loading && items.length === 0?(
        <></>
      ):renderItems()}
    </Nav>
  );
}